export default function autocomplete(element) {
    const searchForm = document.getElementById(element.elementID);
    if (searchForm) {
        import('./lazy-autocomplete.js').then(({ default: lazyAutocomplete }) => lazyAutocomplete(searchForm));
    }
}
//# sourceMappingURL=autocomplete.js.map